module.exports = __webpack_public_path__ + "img/home-img-3.803d674a.jpg";